export default class OMap {
    constructor() {
        this._cache = {};
    }

    has(name) {
        return this._cache.hasOwnProperty(name);
    }

    set(name, obj) {
        this._cache[name] = obj;
    }

    get(name) {
        return this._cache[name];
    }

    values() {
        return this._cache;
    }

    names() {
        let arr = [];
        for (let obj1 in this._cache) {
            arr.push(obj1);
        }
        arr.sort();
        return arr;
    }

    delete(obj) {
        for (let obj1 in this._cache) {
            if (this._cache[obj1] === obj) {
                delete this._cache[obj1];
                obj = null;
                return;
            }
        }
    }

    deleteByName(name) {
        if (this._cache[name]) {
            delete this._cache[name];
        }
    }

    clear() {
        for (let obj1 in this._cache) {
            delete this._cache[obj1];
        }
        this._cache = {};
    }

    clearByKeys(arr) {
        for (let i = 0; i < arr.length; i++) {
            for (let obj1 in this._cache) {
                if (obj1.indexOf(arr[i]) != -1)
                    delete this._cache[obj1];
            }
        }
    }

    calcValues() {
        let value = 0;
        for (let obj1 in this._cache) {
            value += Number(this._cache[obj1]);
        }
        return value;
    }

    createCopy() {
        let result = new OMap();
        let data = {};
        for (let obj1 in this._cache) {
            data[obj1] = this._cache[obj1];
        }
        result._cache = data;
        return result;
    }

    get length() {
        let len = 0;
        for (let prop in this._cache) {
            if (this._cache[prop] != null) {
                len++;
            }
        }

        return len;
    }

    get isEmpty() {
        return (this.length <= 0);
    }
}
